export function extractTempKeysFromHtml(html: string): string[] {
  const tempKeys: string[] = [];
  const marker = "#tempKey=";
  const imgSrcRegex = new RegExp(`${marker}[^"'\\s]+`, "g");
  let match;
  while ((match = imgSrcRegex.exec(html)) !== null) {
    tempKeys.push(match[0].slice(marker.length));
  }
  return tempKeys;
}

export function replaceBase64WithTempKeys(html: string, urlFormatter: (tempKey: string) => string): string {
  return html.replace(
    /src="data:[^"]*#tempKey=([^"]+)"/g,
    (_, tempKey) => `src="${urlFormatter(tempKey)}"`,
  );
}

/** The editor's HTML as one line of readable text, for places that quote a comment inline. */
export function htmlToPlainText(html: string | undefined): string {
  const dom = new DOMParser().parseFromString(html || "", "text/html");
  // Block boundaries carry no text of their own, so `<p>a</p><p>b</p>` would otherwise read "ab".
  dom.body.querySelectorAll("p, div, li, br, h1, h2, h3, h4, h5, h6, blockquote, pre").forEach((el) => el.after(" "));
  return (dom.body.textContent || "").replace(/\s+/g, " ").trim();
}

/**
 * Each image's name, in document order: its `alt`, which the editor's upload node sets from the uploaded
 * file's name. An image without one (pasted from elsewhere) is an empty string.
 */
export function extractImageNames(html: string | undefined): string[] {
  const dom = new DOMParser().parseFromString(html || "", "text/html");
  return Array.from(dom.querySelectorAll("img"), (img) => img.alt.trim());
}

/** True when the editor's HTML carries no visible text or image — an empty tiptap doc is still `<p></p>`. */
export function isHtmlEmpty(html: string): boolean {
  const dom = new DOMParser().parseFromString(html || "", "text/html");
  return (dom.documentElement.textContent || "").trim() === "" && !dom.querySelector("img");
}
